/**
 * Looks up City / State / Country for an Indian pincode.
 * Returns null if the pincode is invalid or lookup fails.
 */
export async function lookupPincode(pincode) {
  if (!/^\d{6}$/.test(pincode)) return null;

  try {
    const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
    const data = await res.json();
    const result = data?.[0];

    if (result?.Status === 'Success' && result.PostOffice?.length) {
      const po = result.PostOffice[0];
      return {
        city: po.District || '',
        state: po.State || '',
        country: po.Country || '',
      };
    }
    return null;
  } catch (error) {
    console.log(error.message);
    return null;
  }
}